// extracted by mini-css-extract-plugin
module.exports = {"btns":"setAssistaneceForm_btns__31ONb","selectors":"setAssistaneceForm_selectors__34c7U","textarea":"setAssistaneceForm_textarea__1gLZ5"};